// extracted by mini-css-extract-plugin
export var actionButton = "_il-t";
export var buttonContainer = "_il-0";
export var buttonContainer2 = "_il-1";
export var buttonSection = "_il-2";
export var details = "_il-3";
export var dropdownItem = "_il-5";
export var dropdownItemsContainer = "_il-4";
export var fileInput = "_il-r";
export var headerButton = "_il-6";
export var icon = "_il-7";
export var input = "_il-8";
export var macroListItem = "_il-9";
export var mainContent = "_il-a";
export var microText = "_il-b";
export var modal = "_il-w";
export var optionsButton = "_il-c";
export var paperclip = "_il-s";
export var pillContent = "_il-d";
export var preview = "_il-e";
export var preview2 = "_il-f";
export var quillEditor = "_il-q";
export var selectedMacro = "_il-g";
export var sidebar = "_il-h";
export var sidebarHeader = "_il-j";
export var sidebarList = "_il-i";
export var sidebarListItem = "_il-k";
export var sidebarSearch = "_il-l";
export var snoozeDurationWrapper = "_il-v";
export var statusPillContainer = "_il-m";
export var tagsContainer = "_il-n";
export var unselectedMacro = "_il-o";
export var variable = "_il-u";
export var wrapper = "_il-p";